function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/panel/balloon/contextualballoon
 */
import { Plugin } from 'ckeditor5/src/core';
import BalloonPanelView from './balloonpanelview';
import View from '../../view';
import ButtonView from '../../button/buttonview';
import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
import FocusTracker from '@ckeditor/ckeditor5-utils/src/focustracker';
import toUnit from '@ckeditor/ckeditor5-utils/src/dom/tounit';
import Rect from '@ckeditor/ckeditor5-utils/src/dom/rect';
import prevIcon from '../../../theme/icons/previous-arrow.svg';
import nextIcon from '../../../theme/icons/next-arrow.svg';
import '../../../theme/components/panel/balloonrotator.css';
import '../../../theme/components/panel/fakepanel.css';
var toPx = toUnit('px');
/**
 * Provides the common contextual balloon for the editor.
 *
 * The role of this plugin is to unify the contextual balloons logic, simplify views management and help
 * avoid the unnecessary complexity of handling multiple {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView}
 * instances in the editor.
 *
 * This plugin allows for creating single or multiple panel stacks.
 *
 * Each stack may have multiple views, with the one on the top being visible. When the visible view is removed from the stack,
 * the previous view becomes visible.
 *
 * It might be useful to implement nested navigation in a balloon. For instance, a toolbar view may contain a link button.
 * When you click it, a link view (which lets you set the URL) is created and put on top of the toolbar view, so the link panel
 * is displayed. When you finish editing the link and close (remove) the link view, the toolbar view is visible again.
 *
 * However, there are cases when there are multiple independent balloons to be displayed, for instance, if the selection
 * is inside two inline comments at the same time. For such cases, you can create two independent panel stacks.
 * The contextual balloon plugin will create a navigation bar to let the users switch between these panel stacks using the "Next"
 * and "Previous" buttons.
 *
 * If there are no views in the current stack, the balloon panel will try to switch to the next stack. If there are no
 * panels in any stack, the balloon panel will be hidden.
 *
 * **Note**: To force the balloon panel to show only one view, even if there are other stacks, use the `singleViewMode=true` option
 * when {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon#add adding} a view to a panel.
 *
 * From the implementation point of view, the contextual ballon plugin is reusing a single
 * {@link module:ui/panel/balloon/balloonpanelview~BalloonPanelView} instance to display multiple contextual balloon
 * panels in the editor. It also creates a special {@link module:ui/panel/balloon/contextualballoon~RotatorView rotator view},
 * used to manage multiple panel stacks. Rotator view is a child of the balloon panel view and the parent of the specific
 * view you want to display. If there is more than one panel stack to be displayed, the rotator view will add a
 * navigation bar. If there is only one stack, the rotator view is transparent (it does not add any UI elements).
 *
 * @extends module:core/plugin~Plugin
 */

var ContextualBalloon = /*#__PURE__*/function (_Plugin) {
  _inherits(ContextualBalloon, _Plugin);

  var _super = _createSuper(ContextualBalloon);

  /**
   * @inheritDoc
   */
  function ContextualBalloon(editor) {
    var _this;

    _classCallCheck(this, ContextualBalloon);

    _this = _super.call(this, editor);
    /**
     * The {@link module:utils/dom/position~Options#limiter position limiter}
     * for the {@link #view balloon}, used when no `limiter` has been passed into {@link #add}
     * or {@link #updatePosition}.
     *
     * By default, a function that obtains the farthest DOM
     * {@link module:engine/view/rooteditableelement~RootEditableElement}
     * of the {@link module:engine/view/document~Document#selection}.
     *
     * @member {module:utils/dom/position~Options#limiter} #positionLimiter
     */

    _this.positionLimiter = function () {
      var view = _this.editor.editing.view;
      var viewDocument = view.document;
      var editableElement = viewDocument.selection.editableElement;

      if (editableElement) {
        return view.domConverter.mapViewToDom(editableElement.root);
      }

      return null;
    };
    /**
     * The currently visible view or `null` when there are no views in any stack.
     *
     * @readonly
     * @observable
     * @member {module:ui/view~View|null} #visibleView
     */


    _this.set('visibleView', null);
    /**
     * The common balloon panel view.
     *
     * @readonly
     * @member {module:ui/panel/balloon/balloonpanelview~BalloonPanelView} #view
     */


    _this.view = new BalloonPanelView(editor.locale);
    editor.ui.view.body.add(_this.view);
    editor.ui.focusTracker.add(_this.view.element);
    /**
     * The map of views and their stacks.
     *
     * @private
     * @type {Map.<module:ui/view~View,Set>}
     */

    _this._viewToStack = new Map();
    /**
     * The map of IDs and stacks.
     *
     * @private
     * @type {Map.<String,Set>}
     */

    _this._idToStack = new Map();
    /**
     * A total number of all stacks in the balloon.
     *
     * @private
     * @readonly
     * @observable
     * @member {Number} #_numberOfStacks
     */

    _this.set('_numberOfStacks', 0);
    /**
     * A flag that controls the single view mode.
     *
     * @private
     * @readonly
     * @observable
     * @member {Boolean} #_singleViewMode
     */


    _this.set('_singleViewMode', false);
    /**
     * Rotator view embedded in the contextual balloon.
     * Displays the currently visible view in the balloon and provides navigation for switching stacks.
     *
     * @private
     * @type {module:ui/panel/balloon/contextualballoon~RotatorView}
     */


    _this._rotatorView = _this._createRotatorView();
    /**
     * Displays fake panels under the balloon panel view when multiple stacks are added to the balloon.
     *
     * @private
     * @type {module:ui/view~View}
     */

    _this._fakePanelsView = _this._createFakePanelsView();
    return _this;
  }
  /**
   * Returns `true` when the given view is in one of the stacks. Otherwise returns `false`.
   *
   * @param {module:ui/view~View} view
   * @returns {Boolean}
   */


  _createClass(ContextualBalloon, [{
    key: "hasView",
    value: function hasView(view) {
      return Array.from(this._viewToStack.keys()).includes(view);
    }
    /**
     * Adds a new view to the stack and makes it visible if the current stack is visible
     * or it is the first view in the balloon.
     *
     * @param {Object} data The configuration of the view.
     * @param {String} [data.stackId='main'] The ID of the stack that the view is added to.
     * @param {module:ui/view~View} [data.view] The content of the balloon.
     * @param {module:utils/dom/position~Options} [data.position] Positioning options.
     * @param {String} [data.balloonClassName] An additional CSS class added to the {@link #view balloon} when visible.
     * @param {Boolean} [data.withArrow=true] Whether the {@link #view balloon} should be rendered with an arrow.
     * @param {Boolean} [data.singleViewMode=false] Whether the view should be the only visible view even if other stacks were added.
     */

  }, {
    key: "add",
    value: function add(data) {
      if (this.hasView(data.view)) {
        /**
         * Trying to add configuration of the same view more than once.
         *
         * @error contextualballoon-add-view-exist
         */
        throw new CKEditorError('contextualballoon-add-view-exist', [this, data]);
      }

      var stackId = data.stackId || 'main'; // If new stack is added, creates it and show view from this stack.

      if (!this._idToStack.has(stackId)) {
        this._idToStack.set(stackId, new Map([[data.view, data]]));

        this._viewToStack.set(data.view, this._idToStack.get(stackId));

        this._numberOfStacks = this._idToStack.size;

        if (!this._visibleStack || data.singleViewMode) {
          this.showStack(stackId);
        }

        return;
      }

      var stack = this._idToStack.get(stackId);

      if (data.singleViewMode) {
        this.showStack(stackId);
      } // Add new view to the stack.


      stack.set(data.view, data);

      this._viewToStack.set(data.view, stack); // And display it if is added to the currently visible stack.


      if (stack === this._visibleStack) {
        this._showView(data);
      }
    }
    /**
     * Removes the given view from the stack. If the removed view was visible,
     * the view preceding it in the stack will become visible instead.
     * When there is no view in the stack, the next stack will be displayed.
     * When there are no more stacks, the balloon will hide.
     *
     * @param {module:ui/view~View} view A view to be removed from the balloon.
     */

  }, {
    key: "remove",
    value: function remove(view) {
      if (!this.hasView(view)) {
        /**
         * Trying to remove the configuration of the view not defined in the stack.
         *
         * @error contextualballoon-remove-view-not-exist
         */
        throw new CKEditorError('contextualballoon-remove-view-not-exist', [this, view]);
      }

      var stack = this._viewToStack.get(view);

      if (this._singleViewMode && this.visibleView === view) {
        this._singleViewMode = false;
      } // When visible view will be removed we need to show a preceding view or next stack
      // if a view is the only view in the stack.


      if (this.visibleView === view) {
        if (stack.size === 1) {
          if (this._idToStack.size > 1) {
            this._showNextStack();
          } else {
            this.view.hide();
            this.visibleView = null;

            this._rotatorView.hideView();
          }
        } else {
          this._showView(Array.from(stack.values())[stack.size - 2]);
        }
      }

      if (stack.size === 1) {
        this._idToStack.delete(this._getStackId(stack));

        this._numberOfStacks = this._idToStack.size;
      } else {
        stack.delete(view);
      }

      this._viewToStack.delete(view);
    }
    /**
     * Updates the position of the balloon using the position data of the first visible view in the stack.
     * When new position data is given, the position data of the currently visible view will be updated.
     *
     * @param {module:utils/dom/position~Options} [position] position options.
     */

  }, {
    key: "updatePosition",
    value: function updatePosition(position) {
      if (position) {
        this._visibleStack.get(this.visibleView).position = position;
      }

      this.view.pin(this._getBalloonPosition());

      this._fakePanelsView.updatePosition();
    }
    /**
     * Shows the last view from the stack of a given ID.
     *
     * @param {String} id
     */

  }, {
    key: "showStack",
    value: function showStack(id) {
      this.visibleStack = id;

      var stack = this._idToStack.get(id);

      if (!stack) {
        /**
         * Trying to show a stack that does not exist.
         *
         * @error contextualballoon-showstack-stack-not-exist
         */
        throw new CKEditorError('contextualballoon-showstack-stack-not-exist', this);
      }

      if (this._visibleStack === stack) {
        return;
      }

      this._showView(Array.from(stack.values()).pop());
    }
    /**
     * Returns the stack of the currently visible view.
     *
     * @private
     * @type {Set}
     */

  }, {
    key: "_visibleStack",
    get: function get() {
      return this._viewToStack.get(this.visibleView);
    }
    /**
     * Returns the ID of the given stack.
     *
     * @private
     * @param {Set} stack
     * @returns {String}
     */

  }, {
    key: "_getStackId",
    value: function _getStackId(stack) {
      var entry = Array.from(this._idToStack.entries()).find(function (entry) {
        return entry[1] === stack;
      });
      return entry[0];
    }
    /**
     * Shows the last view from the next stack.
     *
     * @private
     */

  }, {
    key: "_showNextStack",
    value: function _showNextStack() {
      var stacks = Array.from(this._idToStack.values());
      var nextIndex = stacks.indexOf(this._visibleStack) + 1;

      if (!stacks[nextIndex]) {
        nextIndex = 0;
      }

      this.showStack(this._getStackId(stacks[nextIndex]));
    }
    /**
     * Shows the last view from the previous stack.
     *
     * @private
     */

  }, {
    key: "_showPrevStack",
    value: function _showPrevStack() {
      var stacks = Array.from(this._idToStack.values());
      var nextIndex = stacks.indexOf(this._visibleStack) - 1;

      if (!stacks[nextIndex]) {
        nextIndex = stacks.length - 1;
      }

      this.showStack(this._getStackId(stacks[nextIndex]));
    }
    /**
     * Creates a rotator view.
     *
     * @private
     * @returns {module:ui/panel/balloon/contextualballoon~RotatorView}
     */

  }, {
    key: "_createRotatorView",
    value: function _createRotatorView() {
      var _this2 = this;

      var view = new RotatorView(this.editor.locale);
      var t = this.editor.locale.t;
      this.view.content.add(view); // Hide navigation when there is only a one stack & not in single view mode.

      view.bind('isNavigationVisible').to(this, '_numberOfStacks', this, '_singleViewMode', function (value, isSingleViewMode) {
        return !isSingleViewMode && value > 1;
      }); // Update balloon position after toggling navigation.

      view.on('change:isNavigationVisible', function () {
        return _this2.updatePosition();
      }, {
        priority: 'low'
      }); // Update stacks counter value.

      view.bind('counter').to(this, 'visibleView', this, '_numberOfStacks', function (visibleView, numberOfStacks) {
        if (numberOfStacks < 2) {
          return '';
        }

        var current = Array.from(_this2._idToStack.values()).indexOf(_this2._visibleStack) + 1;
        return t('%0 of %1', [current, numberOfStacks]);
      });
      view.buttonNextView.on('execute', function () {
        // When current view has a focus then move focus to the editable before removing it,
        // otherwise editor will lost focus.
        if (view.focusTracker.isFocused) {
          _this2.editor.editing.view.focus();
        }

        _this2._showNextStack();
      });
      view.buttonPrevView.on('execute', function () {
        // When current view has a focus then move focus to the editable before removing it,
        // otherwise editor will lost focus.
        if (view.focusTracker.isFocused) {
          _this2.editor.editing.view.focus();
        }

        _this2._showPrevStack();
      });
      return view;
    }
    /**
     * @private
     * @returns {module:ui/view~View}
     */

  }, {
    key: "_createFakePanelsView",
    value: function _createFakePanelsView() {
      var view = new FakePanelsView(this.editor.locale, this.view);
      view.bind('numberOfPanels').to(this, '_numberOfStacks', this, '_singleViewMode', function (number, isSingleViewMode) {
        var showPanels = !isSingleViewMode && number >= 2;
        return showPanels ? Math.min(number - 1, 2) : 0;
      });
      view.listenTo(this.view, 'change:top', function () {
        return view.updatePosition();
      });
      view.listenTo(this.view, 'change:left', function () {
        return view.updatePosition();
      });
      this.editor.ui.view.body.add(view);
      return view;
    }
    /**
     * Sets the view as the content of the balloon and attaches the balloon using position
     * options of the first view.
     *
     * @private
     * @param {Object} data Configuration.
     * @param {module:ui/view~View} [data.view] The view to show in the balloon.
     * @param {String} [data.balloonClassName=''] Additional class name which will be added to the {@link #view balloon}.
     * @param {Boolean} [data.withArrow=true] Whether the {@link #view balloon} should be rendered with an arrow.
     */

  }, {
    key: "_showView",
    value: function _showView(_ref) {
      var view = _ref.view,
          _ref$balloonClassName = _ref.balloonClassName,
          balloonClassName = _ref$balloonClassName === void 0 ? '' : _ref$balloonClassName,
          _ref$withArrow = _ref.withArrow,
          withArrow = _ref$withArrow === void 0 ? true : _ref$withArrow,
          _ref$singleViewMode = _ref.singleViewMode,
          singleViewMode = _ref$singleViewMode === void 0 ? false : _ref$singleViewMode;
      this.view.class = balloonClassName;
      this.view.withArrow = withArrow;

      this._rotatorView.showView(view);

      this.visibleView = view;
      this.view.pin(this._getBalloonPosition());

      this._fakePanelsView.updatePosition();

      if (singleViewMode) {
        this._singleViewMode = true;
      }
    }
    /**
     * Returns position options of the last view in the stack.
     * This keeps the balloon in the same position when the view is changed.
     *
     * @private
     * @returns {module:utils/dom/position~Options}
     */

  }, {
    key: "_getBalloonPosition",
    value: function _getBalloonPosition() {
      var position = Array.from(this._visibleStack.values()).pop().position; // Use the default limiter if none has been specified.

      if (position && !position.limiter) {
        // Don't modify the original options object.
        position = Object.assign({}, position, {
          limiter: this.positionLimiter
        });
      }

      return position;
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'ContextualBalloon';
    }
  }]);

  return ContextualBalloon;
}(Plugin);
/**
 * Rotator view is a helper class for the {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon ContextualBalloon}.
 * It is used for displaying the last view from the current stack and providing navigation buttons for switching stacks.
 * See the {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon ContextualBalloon} documentation to learn more.
 *
 * @extends module:ui/view~View
 */


export { ContextualBalloon as default };

var RotatorView = /*#__PURE__*/function (_View) {
  _inherits(RotatorView, _View);

  var _super2 = _createSuper(RotatorView);

  /**
   * @inheritDoc
   */
  function RotatorView(locale) {
    var _this3;

    _classCallCheck(this, RotatorView);

    _this3 = _super2.call(this, locale);
    var t = locale.t;
    var bind = _this3.bindTemplate;
    /**
     * Defines whether navigation is visible or not.
     *
     * @member {Boolean} #isNavigationVisible
     */

    _this3.set('isNavigationVisible', true);
    /**
     * Used for checking if a view is focused or not.
     *
     * @type {module:utils/focustracker~FocusTracker}
     */


    _this3.focusTracker = new FocusTracker();
    /**
     * Navigation button for switching the stack to the previous one.
     *
     * @type {module:ui/button/buttonview~ButtonView}
     */

    _this3.buttonPrevView = _this3._createButtonView(t('Previous'), prevIcon);
    /**
     * Navigation button for switching the stack to the next one.
     *
     * @type {module:ui/button/buttonview~ButtonView}
     */

    _this3.buttonNextView = _this3._createButtonView(t('Next'), nextIcon);
    /**
     * A collection of the child views that creates the rotator content.
     *
     * @readonly
     * @type {module:ui/viewcollection~ViewCollection}
     */

    _this3.content = _this3.createCollection();

    _this3.setTemplate({
      tag: 'div',
      attributes: {
        class: ['ck', 'ck-balloon-rotator'],
        'z-index': '-1'
      },
      children: [{
        tag: 'div',
        attributes: {
          class: ['ck-balloon-rotator__navigation', bind.to('isNavigationVisible', function (value) {
            return value ? '' : 'ck-hidden';
          })]
        },
        children: [_this3.buttonPrevView, {
          tag: 'span',
          attributes: {
            class: ['ck-balloon-rotator__counter']
          },
          children: [{
            text: bind.to('counter')
          }]
        }, _this3.buttonNextView]
      }, {
        tag: 'div',
        attributes: {
          class: 'ck-balloon-rotator__content'
        },
        children: _this3.content
      }]
    });

    return _this3;
  }
  /**
   * @inheritDoc
   */


  _createClass(RotatorView, [{
    key: "render",
    value: function render() {
      _get(_getPrototypeOf(RotatorView.prototype), "render", this).call(this);

      this.focusTracker.add(this.element);
    }
    /**
     * Shows a given view.
     *
     * @param {module:ui/view~View} view The view to show.
     */

  }, {
    key: "showView",
    value: function showView(view) {
      this.hideView();
      this.content.add(view);
    }
    /**
     * Hides the currently displayed view.
     */

  }, {
    key: "hideView",
    value: function hideView() {
      this.content.clear();
    }
    /**
     * Creates a navigation button view.
     *
     * @private
     * @param {String} label The button label.
     * @param {String} icon The button icon.
     * @returns {module:ui/button/buttonview~ButtonView}
     */

  }, {
    key: "_createButtonView",
    value: function _createButtonView(label, icon) {
      var view = new ButtonView(this.locale);
      view.set({
        label: label,
        icon: icon,
        tooltip: true
      });
      return view;
    }
  }]);

  return RotatorView;
}(View); // Displays additional layers under the balloon when multiple stacks are added to the balloon.
//
// @private
// @extends module:ui/view~View


var FakePanelsView = /*#__PURE__*/function (_View2) {
  _inherits(FakePanelsView, _View2);

  var _super3 = _createSuper(FakePanelsView);

  // @inheritDoc
  function FakePanelsView(locale, balloonPanelView) {
    var _this4;

    _classCallCheck(this, FakePanelsView);

    _this4 = _super3.call(this, locale);
    var bind = _this4.bindTemplate; // Fake panels top offset.
    //
    // @observable
    // @member {Number} #top

    _this4.set('top', 0); // Fake panels left offset.
    //
    // @observable
    // @member {Number} #left


    _this4.set('left', 0); // Fake panels height.
    //
    // @observable
    // @member {Number} #height


    _this4.set('height', 0); // Fake panels width.
    //
    // @observable
    // @member {Number} #width


    _this4.set('width', 0); // Number of rendered fake panels.
    //
    // @observable
    // @member {Number} #numberOfPanels


    _this4.set('numberOfPanels', 0); // Collection of the child views which creates fake panel content.
    //
    // @readonly
    // @type {module:ui/viewcollection~ViewCollection}


    _this4.content = _this4.createCollection(); // Context.
    //
    // @private
    // @type {module:ui/panel/balloon/balloonpanelview~BalloonPanelView}

    _this4._balloonPanelView = balloonPanelView;

    _this4.setTemplate({
      tag: 'div',
      attributes: {
        class: ['ck-fake-panel', bind.to('numberOfPanels', function (number) {
          return number ? '' : 'ck-hidden';
        })],
        style: {
          top: bind.to('top', toPx),
          left: bind.to('left', toPx),
          width: bind.to('width', toPx),
          height: bind.to('height', toPx)
        }
      },
      children: _this4.content
    });

    _this4.on('change:numberOfPanels', function (evt, name, next, prev) {
      if (next > prev) {
        _this4._addPanels(next - prev);
      } else {
        _this4._removePanels(prev - next);
      }

      _this4.updatePosition();
    });

    return _this4;
  } // @private
  // @param {Number} number


  _createClass(FakePanelsView, [{
    key: "_addPanels",
    value: function _addPanels(number) {
      while (number--) {
        var view = new View();
        view.setTemplate({
          tag: 'div'
        });
        this.content.add(view);
        this.registerChild(view);
      }
    } // @private
    // @param {Number} number

  }, {
    key: "_removePanels",
    value: function _removePanels(number) {
      while (number--) {
        var view = this.content.last;
        this.content.remove(view);
        this.deregisterChild(view);
        view.destroy();
      }
    } // Updates coordinates of fake panels.

  }, {
    key: "updatePosition",
    value: function updatePosition() {
      if (this.numberOfPanels) {
        var _this$_balloonPanelVi = this._balloonPanelView,
            top = _this$_balloonPanelVi.top,
            left = _this$_balloonPanelVi.left;

        var _Rect = new Rect(this._balloonPanelView.element),
            width = _Rect.width,
            height = _Rect.height;

        Object.assign(this, {
          top: top,
          left: left,
          width: width,
          height: height
        });
      }
    }
  }]);

  return FakePanelsView;
}(View);